import { Alert, Linking } from "react-native";
import React, { useState } from "react";
import { View, Text, TextInput, TouchableOpacity, Image } from "react-native";
import { config } from "../config";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../types/navigation";
import { styles } from "../components/shared/styles/LoginScreenStyles";
import { registrationStyles as regStyles } from "../components/shared/styles/registrationStyles";
import { handlePhone } from "../components/shared/utils/valid";
import { AuthService } from "../components/shared/services/auth.service";
import { verificationService } from "../services/verification.service";
import LoadingSpinnerTrans from "../components/shared/LoadingSpinner";
import SharedAuthComponent from "../components/shared/SharedAuthComponent";
import { AuthResponse } from "../components/shared/types/auth";
import { getResponsiveSize } from "../components/shared/styles/globalStyles";
import { LoadingStates } from "../components/shared/constants/loadingStates";
import { userService } from "../services/user.service";
import { secureStoreService } from "../components/shared/services/secure-store.service";
import { DecodedToken } from "../types/token";

const authService = new AuthService();
const handleTerms = () => Linking.openURL(config.pages.terms);
const handlePrivacy = () => Linking.openURL(config.pages.policy);

type Props = StackScreenProps<RootStackParamList, "Login"> & {
  route: {
    params?: {
      showPhoneInput?: boolean;
    };
  };
};

const LoginScreen: React.FC<Props> = ({ navigation, route }) => {
  const [loading, setLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("+91");
  const [focusedInput, setFocusedInput] = useState<string | null>(null);
  const [loadText, setloadText] = useState<string>("");

  const [phoneError, setPhoneError] = useState("");
  const [showPhoneInput, setShowPhoneInput] = useState(
    route.params?.showPhoneInput || false
  );

  const handlePhoneAuth = async () => {
    try {
      setLoading(true);
      setloadText(LoadingStates.OTP);
      const response = await verificationService.initiateVerification(
        phoneNumber
      );

      navigation.navigate("OTPVerification", {
        phoneNumber,
        verSessId: response.verificationSessionId,
        successCallback: async () => {
          const data: DecodedToken | null =
            await secureStoreService.getDecodedAccessToken();
          if (!data || !data?.restUserId) {
            Alert.alert("Error", "Error finding user please try again");
            return;
          }

          // await userService.getLatestUserAndCacheUpdate(data.restUserId);
        },
      });
    } catch (error: any) {
      Alert.alert(
        "Error",
        error.message || "Failed to send OTP. Please try again."
      );
    } finally {
      setLoading(false);
      setloadText(LoadingStates.EMPTY);
    }
  };

  return (
    <SharedAuthComponent
      isLoginMode={true}
      loginDividerText="Log in or sign up"
    >
      {loading && <LoadingSpinnerTrans text={loadText} />}

      {!showPhoneInput ? (
        <View style={styles.formContainer}>
          <TextInput
            style={[
              styles.input,
              focusedInput === "phone" && styles.inputFocused,
            ]}
            placeholder="Phone Number"
            value={phoneNumber}
            onChangeText={(text) =>
              handlePhone(text, setPhoneNumber, setPhoneError)
            }
            onFocus={() => setFocusedInput("phone")}
            onBlur={() => setFocusedInput(null)}
            keyboardType="numeric"
            maxLength={13}
          />
          {phoneError && <Text style={styles.errorText}>{phoneError}</Text>}

          <TouchableOpacity
            style={[
              styles.submitButton,
              phoneError ? styles.disabledButton : null,
            ]}
            onPress={handlePhoneAuth}
            disabled={!!phoneError || phoneNumber.length < 10}
          >
            <Text style={styles.submitButtonText}>Continue</Text>
          </TouchableOpacity>

          <View
            style={[
              styles.dividerContainer,
              {
                marginTop: getResponsiveSize(8),
                marginBottom: getResponsiveSize(8),
              },
            ]}
          ></View>

          <Text style={styles.termsText}>
            By continuing, you agree to our{" "}
            <Text style={regStyles.termsLink} onPress={handleTerms}>
              Terms of Service
            </Text>{" "}
            and{" "}
            <Text style={regStyles.termsLink} onPress={handlePrivacy}>
              Privacy Policy
            </Text>
          </Text>
        </View>
      ) : (
        <View style={styles.formContainer}>
          <Text style={styles.subtitle}>Verify Your Phone Number</Text>
          <TextInput
            style={[
              styles.input,
              focusedInput === "phone" && styles.inputFocused,
            ]}
            placeholder="Phone Number"
            value={phoneNumber}
            onChangeText={(text) =>
              handlePhone(text, setPhoneNumber, setPhoneError)
            }
            onFocus={() => setFocusedInput("phone")}
            onBlur={() => setFocusedInput(null)}
            keyboardType="numeric"
            maxLength={13}
          />
          {phoneError && <Text style={styles.errorText}>{phoneError}</Text>}
          <TouchableOpacity
            style={[
              styles.submitButton,
              phoneError ? styles.disabledButton : null,
            ]}
            onPress={handlePhoneAuth}
            disabled={!!phoneError}
          >
            <Text style={styles.submitButtonText}>Get OTP</Text>
          </TouchableOpacity>
        </View>
      )}
    </SharedAuthComponent>
  );
};

export default LoginScreen;
